<template>
  <div v-if="content" class="material-icons md-16 w-100" :class="dynamicClass">
    {{ icon }}
  </div>
  <div v-else class="not-set w-100" :class="dynamicClass">
    {{ notSet }}
  </div>
</template>

<script>
export default {
  name: 'SignatureField',
  props: {
    content: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClass() {
      return this.inDetailView || this.isCardView
        ? this.content
          ? 'text-start negate-gap'
          : 'text-start'
        : 'text-center'
    },
    icon() {
      return this.type === 'wpaint' ? 'brush' : 'draw'
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    notSet() {
      return this.$i18n.t('not_set')
    },
  },
}
</script>

<style lang="scss" scoped>
.not-set {
  color: $color-not-set;
}
.negate-gap {
  margin-inline-start: -3px;
}
</style>
